<template>
  <div>
    <LKProgressCircular
      v-if="isLoadingAsyncData"
      overlay
      :size="50"
      style="align-items: start; padding-top: 30vh;"
    />

    <MainForm
      v-else
      :mun-meh="single"
      :levels="levels"
      :slug="slug"
      :topic-slug="topicSlug"
    />
  </div>
</template>

<script>
import { toNumber } from 'lodash'
import { LkMunMehModel as Model } from '../Model'
import { lkMunMehStoreModule as StoreModule } from '../store'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'

import { createViewMixin } from '@/helpers/mixins/createViewMixin'
import { BASE_DELIMITER_URL } from '@/views/LKMunMeh/utils'

const mixinOptions = { Model, StoreModule }
const viewMixin = createViewMixin(mixinOptions)

const MainForm = () => import(
  /* webpackChunkName: "LKMunMehMainForm" */
  '@/views/LKMunMeh/Form/components/LKMunMehForm.vue'
)

export default {
  name: 'LKMunMehFormView',
  components: {
    MainForm,
    LKProgressCircular,
  },
  mixins: [viewMixin],
  props: {
    id: {
      type: [String, Number],
      default() {
        return this.$route.params.munMehId
      },
    },
    viewType: String,
  },
  data: () => ({
    slug: null,
    topicSlug: null,
    levels: [],
  }),
  created() {
    this.onConfigurationChanged(this.$route)
  },
  methods: {
    onConfigurationChanged(route) {
      const { params } = route

      if (params && params.levels) {
        this.levels = params.levels.replace(/\/$/, '').split(BASE_DELIMITER_URL).map((el) => toNumber(el))
      } else {
        this.levels = []
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.onConfigurationChanged(to)
    next()
  },
  beforeRouteUpdate(to, from, next) {
    this.onConfigurationChanged(to)
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.params.topic_slug) {
        // eslint-disable-next-line no-param-reassign
        vm.topicSlug = from.params.topic_slug
      }

      if (to.params.slug) {
        // eslint-disable-next-line no-param-reassign
        vm.slug = to.params.slug
      }
    })
  },
}
</script>

